import { Link } from 'react-router-dom';

import { PanelSectionHeader } from './PanelSectionHeader';
import { TiempoRelativo } from './TiempoRelativo';

/** Lo que la sección necesita de una conversación de lead con respuesta sin leer. */
export interface LeadSinLeer {
  id: string;
  subject: string | null;
  last_inbound_at: string | null;
}

/** Bloque «Leads» de la campanita. Extraído de NotificationBell para no pasar el límite de tamaño. */
export function LeadsSection({ leads, onActivate }: { leads: readonly LeadSinLeer[]; onActivate: () => void }) {
  if (leads.length === 0) return null;
  return (
    <div>
      <PanelSectionHeader title="Leads" aside={<span className="text-primary">{leads.length} sin leer</span>} />
      <ul>
        {leads.slice(0, 6).map((l) => (
          <li key={l.id} className="hover:bg-surface-hi/40 border-border-dim/40 border-b last:border-0">
            <Link to={`/leads/${l.id}`} onClick={onActivate} className="flex items-center gap-2 px-3.5 py-2 text-caption">
              <span className="bg-primary h-1.5 w-1.5 shrink-0 rounded-full" />
              <span className="text-foreground flex-1 truncate">Respondió · {l.subject ?? '(sin asunto)'}</span>
              <TiempoRelativo iso={l.last_inbound_at} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
